import useHandleAddNewLanguage from './useHandleAddNewLanguage'

export default useHandleAddNewLanguage
